import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import AbstractForm from '../forms/AbstractForm'
import { Typography } from '../styled'
import { useTranslation } from 'react-i18next'
import { deepNavy } from './styles'

export const ProfileSectionConfirmationModal = ({
  show,
  handleClose,
  children,
}) => {
  return (
    <Modal show={show} onHide={handleClose} style={{ marginTop: '5%' }}>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

ProfileSectionConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  children: PropTypes.node.isRequired,
}

const ProfileEditModal = ({
  isEdit = false,
  show,
  handleClose,
  titleKey,
  children,
}) => {
  const { t } = useTranslation()
  return (
    <Modal show={show} onHide={handleClose} style={{ marginTop: '5%' }}>
      <Modal.Header closeButton className="mx-3">
        <Modal.Title style={{ marginLeft: '-15px' }}>
          <Typography size={16} bold color={deepNavy}>
            {isEdit ? t('general.edit') : t('general.add')} {titleKey}
          </Typography>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

ProfileEditModal.propTypes = {
  isEdit: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  children: PropTypes.node.isRequired,
}

const ProfileSectionItemModal = ({
  defaultValues = {},
  isEdit = false,
  show,
  setShow,
  handleSubmit,
  objectKey,
  triggerChange,
}) => {
  const { t } = useTranslation()
  const handleClose = () => {
    setShow(false)
  }

  const validateEmptyFields = (data) => {
    return (
      Object.values(data).every((value) =>
        ['', null, undefined].includes(value),
      ) ||
      Object.values(data)
        .filter((value) => value)
        .filter((value) => typeof value === 'string')
        .every((value) => value.trim().length === 0)
    )
  }

  const handleClick = (data, setIsLoading) => {
    if (validateEmptyFields(data)) {
      handleClose()
      return
    }
    handleSubmit(data)
    triggerChange((prev) => !prev)
    setIsLoading(false)
    handleClose()
  }

  const experienceInputs = [
    {
      name: 'position',
      label: t('profile.position'),
      type: 'text',
      width: 12,
      fontSize: 12,
    },
    {
      name: 'company',
      label: t('profile.company'),
      type: 'text',
      width: 12,
      fontSize: 12,
    },
    {
      name: 'startDate',
      label: t('profile.startDate'),
      type: 'date',
      width: 12,
      fontSize: 12,
    },
    {
      name: 'endDate',
      label: t('profile.endDate'),
      type: 'date',
      width: 12,
      fontSize: 12,
    },
    {
      name: 'description',
      label: t('profile.description'),
      type: 'textarea',
      width: 12,
      fontSize: 12,
      rows: 5,
    },
  ]

  const educationInputs = [
    {
      name: 'institute',
      label: t('profile.institute'),
      type: 'text',
      width: 12,
      fontSize: 12,
    },
    {
      name: 'fieldOfStudy',
      label: t('profile.fieldOfStudy'),
      type: 'text',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'degree',
      label: t('profile.degree'),
      type: 'text',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'startDate',
      label: t('profile.startDate'),
      type: 'date',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'endDate',
      label: t('profile.endDate'),
      type: 'date',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'graduationProject',
      label: t('profile.graduationProject'),
      type: 'textarea',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'graduationProjectGrade',
      label: t('profile.graduationProjectGrade'),
      type: 'textarea',
      width: 6,
      fontSize: 12,
    },
    {
      name: 'graduationProjectDescription',
      label: t('profile.graduationProjectDescription'),
      type: 'textarea',
      width: 12,
      fontSize: 12,
      rows: 5,
    },
  ]

  const inputs = {
    experience: experienceInputs,
    education: educationInputs,
    '': [],
  }

  const actions = [
    {
      field: 'cancel',
      text: isEdit ? t('general.discard') : t('general.cancel'),
      onClick: handleClose,
    },
    {
      field: 'submit',
      text: isEdit ? t('general.save') : t('general.add'),
      onClick: handleClick,
      variant: 'success',
    },
  ]

  return (
    <ProfileEditModal
      isEdit={isEdit}
      show={show}
      handleClose={handleClose}
      titleKey={t(`profile.${objectKey}`)}
    >
      <AbstractForm
        inputs={inputs[objectKey]}
        defaultValues={defaultValues}
        actions={actions}
      />
    </ProfileEditModal>
  )
}

ProfileSectionItemModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  defaultValues: PropTypes.object,
  isEdit: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  objectKey: PropTypes.string,
  triggerChange: PropTypes.func.isRequired,
}

export default ProfileSectionItemModal
